<template>
  <div>
    <loader-component v-if="isLoading" class="float-center" />
    <div id="add-user" class="m-t-10">
      <form action="#" v-on:submit.prevent="submitForm">
        <div class="form-group" :key="keyTable">
          <table
            class="table table-bordered"
            id="listBarModal"
            width="100%"
          >
            <thead>
              <tr>
                <th width="20%" class="text-center">Media</th>
                <th width="20%" class="text-center">Sentimen Positif</th>
                <th width="20%" class="text-center">Sentimen Netral</th>
                <th width="20%" class="text-center">Sentimen Negatif</th>
                <th width="5%" class="text-center">Jumlah</th>
              </tr>
            </thead>
            <tbody class="text-center"></tbody>
          </table>
        </div>
        <div class="form-group">
          <pagination-component
            v-if="page_info != null"
            :key="pagination_key"
            class="pull-left"
            :data="page_info"
            :goto="true"
          />
        </div>
        <div class="form-group" align="right">
          <button
            type="button"
            class="btn btn-danger m-r-5"
            data-dismiss="modal"
          >
            Tutup
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import pagintaion_component from "@/views/components/pagination.vue";
import loader_component from "@/views/components/loader.vue";

$.pgNotification = notif;

export default {
  name: "modal_newstrend_chart",
  components: {
    "pagination-component": pagintaion_component,
    "loader-component": loader_component,
  },
  props: {
    data: Array,
  },
  data() {
    return {
      id_stream: this.data[0].idStream,
      dataBerita: {},
      page_info: null,
      pagination_key: 0,
      dataStream: [],
      keyTable: 10,
      isLoading: true,
    };
  },
  methods: {
    getData: function () {
      let self = this;
      let api = process.env.VUE_APP_API_URL + "/newstrend/trend-account";
      this.$http
        .post(api, {
          ids: self.id_stream,
        })
        .then((response) => {
          if (response.status == 204) {
            self.dataBerita = {};
            self.page_info = null;
          } else {
            this.isLoading = false;
            self.table.clear().draw();
            self.dataBerita = response.data.streams;
            for (let index in self.dataBerita) {
              let media = self.dataBerita[index]._id;
              let sentimen_positif = self.dataBerita[index].positif;
              let sentimen_netral = self.dataBerita[index].netral;
              let sentimen_negatif = self.dataBerita[index].negatif;
              let jumlah = self.dataBerita[index].count;
              self.table.row
                .add([
                  media,
                  sentimen_positif,
                  sentimen_netral,
                  sentimen_negatif,
                  jumlah,
                ])
                .node().id = index;
              self.table.columns.adjust().draw();
            }
            if (this.isLoading) {
              $("#add-user").hide();
            } else {
              $("#add-user").show();
            }
          }
        });
    },
  },
  created: function () {
    this.table = $("#listBarModal").DataTable();
  },
  mounted: function () {
    this.getData();
    this.table = $("#listBarModal").DataTable({
      order: [4, "desc"],
    });
    if (this.isLoading) {
      $("#add-user").hide();
    } else {
      $("#add-user").show();
    }
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>